import {AI_AGENT_CONFIRMED_TEXT_DEFAULT_KEY, AI_AGENT_CONFIRMED_TEXT_KEYS} from '../constants';

/** The aiAgent i18n key of the line the chat closes a creation with — an intent it does not know gets the generic one. */
export function getProposalConfirmedKey(intent: string): string {
    return Object.hasOwn(AI_AGENT_CONFIRMED_TEXT_KEYS, intent)
        ? AI_AGENT_CONFIRMED_TEXT_KEYS[intent]
        : AI_AGENT_CONFIRMED_TEXT_DEFAULT_KEY;
}
